module.exports = __webpack_public_path__ + "img/part_01.20a92707.png";